import {FC, useMemo} from "react";

import {
  IMetricsData,
  TBattery,
} from "../../../pages/Dashboard/Dashboard.type";
import {getBatteryIconByPhase} from "../../../helper/batteryIcons";
import {computeEntityBatteries} from "../../../helper/batteryMaturity";

interface IProps {
  type: "tehnologie" | "cluster";
  /** Gartner analytics_data.phase_2025 */
  phase?: string | null;
  metricsData?: IMetricsData | null;
  nameHints?: Array<string | null | undefined>;
  medianSharePatDirection?: number | null;
  /** Precomputed labels (e.g. for CardItem list). */
  batteryRussia?: TBattery;
  batteryWorld?: TBattery;
}

export const SideBarContentMapBattery: FC<IProps> = ({
  type,
  phase,
  metricsData,
  nameHints,
  medianSharePatDirection,
  batteryRussia: batteryRussiaProp,
  batteryWorld: batteryWorldProp,
}) => {
  const computed = useMemo(() => {
    if (batteryWorldProp !== undefined || batteryRussiaProp !== undefined) {
      return {
        world: batteryWorldProp ?? "",
        russia: batteryRussiaProp ?? "",
      };
    }
    return computeEntityBatteries({
      phase,
      metricsData,
      nameHints,
      medianSharePatDirection,
    });
  }, [
    batteryRussiaProp,
    batteryWorldProp,
    phase,
    metricsData,
    nameHints,
    medianSharePatDirection,
  ]);

  if (!computed.world && !computed.russia) {
    return null;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "white",
          gap: 12,
        }}
      >
        <div style={{display: "flex", alignItems: "center", gap: 10}}>
          <img
            src={getBatteryIconByPhase(computed.russia)}
            alt=""
            width={16}
            height={20}
          />
          <span>
            Зрелость {type === "tehnologie" ? "технологии" : "кластера"} в
            России
          </span>
        </div>
        <div style={{textAlign: "right", maxWidth: "55%"}}>
          {computed.russia}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "white",
          gap: 12,
        }}
      >
        <div style={{display: "flex", alignItems: "center", gap: 10}}>
          <img
            src={getBatteryIconByPhase(computed.world)}
            alt=""
            width={16}
            height={20}
          />
          <span>
            Зрелость {type === "tehnologie" ? "технологии" : "кластера"} в мире
          </span>
        </div>
        <div style={{textAlign: "right", maxWidth: "55%"}}>
          {computed.world}
        </div>
      </div>
    </>
  );
};
